import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { SEARCH_QUERY_SUBMITTED } = SNOWPLOW_EVENTS;

export const triggerSellerMessagingSearchQuerySubmittedEvent = (query: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: ANALYTICS_CATEGORIES.ACCOUNT.SELLER_MESSAGING,
		customData: { label: query },
		name: 'dlr_seller_messaging_search_query_submitted',
		schemaName: SEARCH_QUERY_SUBMITTED.SCHEMA,
		version: SEARCH_QUERY_SUBMITTED.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
